import "./ImageCarousel.css";
import { useState, useEffect, useRef } from "react";
import { objectFitPolyfill, addObjectFitAttributes } from "../../objectFitPolyfill";

const ImageCarousel = ({ banners }) => {
  const [index, setIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [supportsObjectFit, setSupportsObjectFit] = useState(true);
  const [supportsTransform, setSupportsTransform] = useState(true);
  const carouselRef = useRef(null);
  const minSwipeDistance = 50;


  useEffect(() => {
    const testEl = document.createElement('div');
    const hasObjectFit = 'objectFit' in testEl.style;
    const hasTransform = 'transform' in testEl.style || 'webkitTransform' in testEl.style;
    
    setSupportsObjectFit(hasObjectFit);
    setSupportsTransform(hasTransform);


    // Aplicar polyfill se necessário
    if (!hasObjectFit) {
      objectFitPolyfill();
    }

    // Adicionar atributos data-object-fit após renderização
    const timer = setTimeout(() => {
      addObjectFitAttributes();
      
      if (!hasObjectFit) {
        setTimeout(() => {
          objectFitPolyfill();
        }, 100);
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [banners]);

  const handlePrev = () => {
    setIndex((prev) => (prev === 0 ? banners.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setIndex((prev) => (prev === banners.length - 1 ? 0 : prev + 1));
  };

  const handleBannerClick = (actionUrl) => {
    if (actionUrl) {
      // const modifiedUrl = actionUrl.replaceAll("reinoplay.app", "mobile.reinoplay.app");
      window.location.href = actionUrl;
    }
  };

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      handleNext();
    } else if (isRightSwipe) {
      handlePrev();
    }
  };

  // Função para calcular o transform de forma compatível
  const getTransformStyle = () => {
    const translateValue = -index * 100;
    
    if (supportsTransform) {
      return { transform: `translateX(${translateValue}%)` };
    } else {
      // Fallback para navegadores muito antigos
      return { left: `${translateValue}%` };
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIndex((prev) => (prev === banners.length - 1 ? 0 : prev + 1));
    }, 10000);

    return () => clearInterval(intervalId);
  }, [banners.length]);

  return (
    <div className="carousel-img-container">
      <div
        ref={carouselRef}
        className="carousel-images-wrapper"
        style={getTransformStyle()}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        {banners.map((banner, i) => (
          <div
            key={banner.banner_id}
            className="carousel-slide"
            onClick={() => handleBannerClick(banner.banner_action_url)}
            style={
              !supportsObjectFit 
                ? { backgroundImage: `url(${banner.banner_url})` }
                : {}
            }
          >
            <img
              src={banner.banner_url}
              alt={banner.banner_title}
              className="image-carousel-image"
              data-object-fit="cover"
              data-object-position="center center"
              style={!supportsObjectFit ? { opacity: 0 } : {}}
            />
            <div className="carousel-content">
              <h2 className="carousel-title">{banner.banner_title}</h2>
              <p className="carousel-subtitle">{banner.banner_subtitle}</p>
            </div>
          </div>
        ))}
      </div>
      <button className="image-carousel-button left" onClick={handlePrev}>‹</button>
      <button className="image-carousel-button right" onClick={handleNext}>›</button>
      <div className="carousel-indicators">
        {banners.map((_, i) => (
          <span
            key={i}
            className={`carousel-dot ${i === index ? "active" : ""}`}
            onClick={() => setIndex(i)}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageCarousel;
